// https://dev.azure.com/hagerty/Hagerty/_git/hagerty-insurance?path=/DBMarineDev/Business/Enumerations/DashboardEnums.cs&version=GBmain&line=142&lineEnd=143&lineStartColumn=1&lineEndColumn=1&lineStyle=plain&_a=contents
// @TODO confirm IDs correctness
var documentsTypes = {
    DECLARATIONS_PAGE: 619,
    ID_CARD: 1468,
    ENDORSEMENT_COVER_LETTER: 1474,
    KEY_FACTS_SHEET: 4434,
    KEY_FACTS_SHEET_2: 5140705,
    KEY_FACTS_SHEET_3: 6547,
    DRIVERS_CLUB: 2079,
    BILLING_SCHEDULE: 2815,
    PRIVACY_POLICY_HAGERTY: 6546,
    PRIVACY_POLICY: 5140462,
};

export { documentsTypes };
